import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            大家都在看
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            根据全网热度与用户口碑精选的优质剧集，每一部都值得你的时间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cardItems.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} — ${item.subtitle}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs font-label font-semibold bg-primary-500 text-white px-2.5 py-1 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {cardItems.slice(4, 7).map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-36 h-44 sm:h-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={`${item.title} — ${item.subtitle}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-2 left-2">
                  <span className="text-xs font-label font-semibold bg-accent-500 text-white px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <h3 className="text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}